const systemNotificationOptions = [
  { id: "Advanced Diagnostics", value: "Advanced Diagnostics" },
  { id: "Experience Coach", value: "Experience Coach" },
  { id: "Battery Level", value: "Battery Level" }
];

export default systemNotificationOptions;
